var formatter = (maxDecimals) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: maxDecimals ? maxDecimals : '2'
})

export function currencyFormatter(val, maxDecimals){
    return formatter(maxDecimals).format((val))
}